<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="container mainContent unselectable" (keydown.enter)="$event.preventDefault()">
<div class="unselectable headerTitle headline">Schäden erfassen</div>
<form id="damageReportForm" class="row">
<div class="largeBreakLine"></div>
<div class="col-12 unselectable subTitle subhead">Schadendetail</div>
<div class="largeBreakLine"></div>
<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
  <mat-form-field class="formField">
    <input #docNum type="text" placeholder="Dokumentennummer" matInput [matAutocomplete]="autoDamageReport" [value]="damageReport.DocNum" readonly>
  </mat-form-field>
</div>
<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
  <mat-form-field class="formField">
    <input #searchElement type="text" placeholder="Schaden suchen..." matInput [formControl]="docNumControl" [matAutocomplete]="autoDamageReport">
    <mat-autocomplete #autoDamageReport="matAutocomplete">
      <mat-option *ngFor="let docNum of filteredDocNums | async" (onSelectionChange)="selectDamageReport(docNum, $event)" [value]="docNum">{{docNum}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
  <div class="formField damageReportIconsContent">
    Status:
    <i (click)="changeDocState(0)" [ngClass]="{ 'green': damageReport.CheckDocStateDone }" class="material-icons damageReportIcons">sentiment_very_satisfied</i>
    <i (click)="changeDocState(1)" [ngClass]="{ 'blue': damageReport.CheckDocStateRelease }" class="material-icons damageReportIcons">sentiment_satisfied</i>
    <i (click)="changeDocState(2)" [ngClass]="{ 'red': damageReport.CheckDocStateIncomplete }" class="material-icons damageReportIcons">mood_bad</i>
  </div>
</div>
<div class="largeBreakLine"></div>
<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
  <mat-form-field class="formField">
    <input name="senderDate" matInput [matDatepicker]="damagePicker" placeholder="Schadendatum" [(ngModel)]="tempDamageDate" [max]="maxDate" (focus)="openDamageDatePicker(damagePicker)" (click)="openDamageDatePicker(damagePicker)" #damageFocus>
    <mat-datepicker-toggle matSuffix [for]="damagePicker"></mat-datepicker-toggle>
    <mat-datepicker #damagePicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="formField">
    <input type="time" name="damageTime" placeholder="Zeit" matInput [value]="damageReport.DamageTime" (change)="changeTime($event)">
  </mat-form-field>
  <mat-form-field class="formField">
    <input type="text" placeholder="Versicherungsart" matInput [formControl]="insuranceControl" [matAutocomplete]="autoInsurance" [value]="damageReport.InsuranceDisplayName">
    <mat-autocomplete #autoInsurance="matAutocomplete" [displayWith]="displayWithText('insurance')">
      <mat-option *ngFor="let item of filteredInsurances | async" (onSelectionChange)="selectInsurance(item)" [value]="item">{{item.InsuranceName}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="formField">
    <input type="text" placeholder="Auftragstyp" matInput [formControl]="jobTypeControl" [matAutocomplete]="autoJobType" [value]="damageReport.JobTypeDisplayName">
    <mat-autocomplete #autoJobType="matAutocomplete" [displayWith]="displayWithText('jobType')">
      <mat-option *ngFor="let item of filteredJobTypes | async" (onSelectionChange)="selectJobType(item)" [value]="item">{{item.JobTypeName}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="formField">
    <input type="text" placeholder="Verursacher" matInput [formControl]="employeeControl" [matAutocomplete]="autoCausedBy" [value]="damageReport.CausedByDisplayName">
    <mat-autocomplete #autoCausedBy="matAutocomplete" [displayWith]="displayWithText('causedBy')">
      <mat-option *ngFor="let item of filteredEmployees | async" (onSelectionChange)="selectEmployee(item)" [value]="item">{{item.LastName}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="formField">
    <input type="text" placeholder="Absender" matInput [formControl]="senderControl" [matAutocomplete]="autoSender" [value]="damageReport.SenderDisplayName">
    <mat-autocomplete #autoSender="matAutocomplete" [displayWith]="displayWithText('receiver')">
      <mat-option *ngFor="let item of filteredSenders | async" (onSelectionChange)="selectSender(item)" [value]="item">{{item.ReceiverName}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="formField">
    <input type="text" placeholder="Rep. Werkstatt" matInput [formControl]="workshopControl" [matAutocomplete]="autoWorkshop" [value]="damageReport.WorkshopDisplayName">
    <mat-autocomplete #autoWorkshop="matAutocomplete" [displayWith]="displayWithText('receiver')">
      <mat-option *ngFor="let item of filteredWorkshops | async" (onSelectionChange)="selectWorkshop(item)" [value]="item">{{item.ReceiverName}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="formField">
    <input type="text" placeholder="Empfänger" matInput [formControl]="receiverControl" [matAutocomplete]="autoReceiver" [value]="damageReport.ReceiverDisplayName">
    <mat-autocomplete #autoReceiver="matAutocomplete" [displayWith]="displayWithText('receiver')">
      <mat-option *ngFor="let item of filteredReceivers | async" (onSelectionChange)="selectReceiver(item)" [value]="item">{{item.ReceiverName}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
  <mat-form-field class="formField">
    <input type="text" placeholder="Marke" matInput [formControl]="brandControl" [matAutocomplete]="autoBrand" [value]="damageReport.BrandDisplayName">
    <mat-autocomplete #autoBrand="matAutocomplete" [displayWith]="displayWithText('carBrand')">
      <mat-option *ngFor="let item of filteredBrands | async" (onSelectionChange)="selectBrand(item)" [value]="item">{{item.CarBrandName}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="formField">
    <input type="text" placeholder="Modell" matInput [formControl]="typeControl" [matAutocomplete]="autoType" [readonly]="damageReport.BrandDisplayName === ''" [value]="damageReport.TypeDisplayName">
    <mat-autocomplete #autoType="matAutocomplete" [displayWith]="displayWithText('carType')">
      <mat-option *ngFor="let item of filteredTypes | async" (onSelectionChange)="selectType(item)" [value]="item">{{item.CarTypeName}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="formField">
    <mat-label>Identifikation</mat-label>
    <input matInput name="identification" [(ngModel)]="damageReport.Identification">
  </mat-form-field>
  <mat-form-field class="formField">
    <mat-label>Kontrollschild</mat-label>
    <input matInput name="license" [(ngModel)]="damageReport.License">
  </mat-form-field>
  <mat-form-field class="formField">
    <mat-label>Chassis-Nummer</mat-label>
    <input matInput name="chassisNo" [(ngModel)]="damageReport.ChassisNo">
  </mat-form-field>
  <mat-form-field class="formField">
    <input type="text" placeholder="Importeur" matInput [formControl]="importerControl" [matAutocomplete]="autoImporter" [value]="damageReport.ImporterDisplayName">
    <mat-autocomplete #autoImporter="matAutocomplete" [displayWith]="displayWithText('importer')">
      <mat-option *ngFor="let item of filteredImporters | async" (onSelectionChange)="selectImporter(item)" [value]="item">{{item.ImporterName}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!--      <mat-form-field class="formField">-->
  <!--        <mat-label>Importeur</mat-label>-->
  <!--        <input matInput [value]="damageReport.ImporterDisplayName" readonly>-->
  <!--      </mat-form-field>-->
  <mat-form-field class="formField">
    <mat-label>Police-Nr.</mat-label>
    <input matInput name="policyNo" [(ngModel)]="damageReport.PolicyNo" readonly>
  </mat-form-field>
  <div class="formFieldCheckbox">
    <mat-checkbox color="primary" name="guilty" [(ngModel)]="damageReport.Guilty">Schuldig</mat-checkbox>
  </div>
</div>
<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
  <mat-form-field class="formField">
    <input name="caseEndDate" matInput [matDatepicker]="caseEndPicker" placeholder="Dossierabschluss" [(ngModel)]="tempCaseEndDate" [max]="maxDate" (focus)="openCaseEndDatePicker(caseEndPicker)" (click)="openCaseEndDatePicker(caseEndPicker)" #caseEndFocus>
    <mat-datepicker-toggle matSuffix [for]="caseEndPicker"></mat-datepicker-toggle>
    <mat-datepicker #caseEndPicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="formField">
    <mat-label>Kostenvoranschlag</mat-label>
    <input matInput name="costEstimate" [(ngModel)]="damageReport.CostEstimate" type="number" class="rightAlign">
    <span matSuffix>&nbsp;CHF</span>
  </mat-form-field>
  <mat-form-field class="formField">
    <mat-label>Schadenbetrag</mat-label>
    <input matInput name="damageAmount" [(ngModel)]="damageReport.DamageAmount" type="number" class="rightAlign" (ngModelChange)="calculateOwnCosts()">
    <span matSuffix>&nbsp;CHF</span>
  </mat-form-field>
  <mat-form-field class="formField">
    <mat-label>Versicherte Leistung</mat-label>
    <input matInput name="insuranceAmount" [(ngModel)]="damageReport.InsuranceAmount" type="number" class="rightAlign" (ngModelChange)="calculateOwnCosts()">
    <span matSuffix>&nbsp;CHF</span>
  </mat-form-field>
  <mat-form-field class="formField">
    <input name="reimbursement" matInput [matDatepicker]="reimbursementPicker" placeholder="Rückvergütung" [(ngModel)]="tempReimbursementDate" (focus)="openReimbursementDatePicker(reimbursementPicker)" (click)="openReimbursementDatePicker(reimbursementPicker)" #reimbursementFocus>
    <mat-datepicker-toggle matSuffix [for]="reimbursementPicker"></mat-datepicker-toggle>
    <mat-datepicker #reimbursementPicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="formField">
    <mat-label>Eigenkosten</mat-label>
    <input matInput name="ownCosts" [(ngModel)]="damageReport.OwnCosts" type="number" class="rightAlign" readonly="readonly">
    <span matSuffix>&nbsp;CHF</span>
  </mat-form-field>
  <div class="formField damageReportIconsContent">
    Rechnung:
    <i (click)="changeInvoiceAmountState(0)" [ngClass]="{ 'green': damageReport.InvoiceAmountLow }" class="material-icons damageReportIcons">arrow_circle_down</i>
    <i (click)="changeInvoiceAmountState(1)" [ngClass]="{ 'blue': damageReport.InvoiceAmountOk }" class="material-icons damageReportIcons">check_circle_outline</i>
    <i (click)="changeInvoiceAmountState(2)" [ngClass]="{ 'red': damageReport.InvoiceAmountHigh }" class="material-icons damageReportIcons">arrow_circle_up</i>
  </div>
</div>
<div class="largeBreakLine"></div>
<div class="col-12 unselectable subTitle subhead">Schäden</div>
<div class="largeBreakLine"></div>
<div class="col-12">
  <div class="row">
    <div id="leftCheckBox" class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
      <mat-checkbox color="primary" name="driverDoor" [(ngModel)]="damageReport.DriverDoor">{{translation.DriversDoor}}</mat-checkbox>
      <mat-checkbox color="primary" name="anotherDoor" [(ngModel)]="damageReport.AnotherDoor">{{translation.AnotherDoor}}</mat-checkbox>
      <mat-checkbox color="primary" name="roof" [(ngModel)]="damageReport.Roof">{{translation.Roof}}</mat-checkbox>
      <mat-checkbox color="primary" name="frontBumper" [(ngModel)]="damageReport.FrontBumper">{{translation.FrontBumper}}</mat-checkbox>
      <mat-checkbox color="primary" name="rearBumper" [(ngModel)]="damageReport.RearBumper">{{translation.RearBumper}}</mat-checkbox>
      <mat-checkbox color="primary" name="frontFender" [(ngModel)]="damageReport.FrontFender">{{translation.FrontFender}}</mat-checkbox>
      <mat-checkbox color="primary" name="rearFender" [(ngModel)]="damageReport.RearFender">{{translation.RearFender}}</mat-checkbox>
    </div>
    <div id="middleCheckBox" class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
      <mat-checkbox color="primary" name="bonnet" [(ngModel)]="damageReport.Bonnet">{{translation.Bonnet}}</mat-checkbox>
      <mat-checkbox color="primary" name="rearCover" [(ngModel)]="damageReport.RearCover">{{translation.RearCover}}</mat-checkbox>
      <mat-checkbox color="primary" name="windshield" [(ngModel)]="damageReport.Windshield">{{translation.Windshield}}</mat-checkbox>
      <mat-checkbox color="primary" name="rearWindow" [(ngModel)]="damageReport.RearWindow">{{translation.RearWindow}}</mat-checkbox>
      <mat-checkbox color="primary" name="steeringWheel" [(ngModel)]="damageReport.SteeringWheel">{{translation.SteeringWheel}}</mat-checkbox>
      <mat-checkbox color="primary" name="underbody" [(ngModel)]="damageReport.Underbody">{{translation.UnderBody}}</mat-checkbox>
      <mat-checkbox color="primary" name="rim" [(ngModel)]="damageReport.Rim">{{translation.Rim}}</mat-checkbox>
    </div>
    <div id="rightCheckBox" class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
      <mat-checkbox color="primary" name="tire" [(ngModel)]="damageReport.Tire">{{translation.Tire}}</mat-checkbox>
      <mat-checkbox color="primary" name="sideMirror" [(ngModel)]="damageReport.SideMirror">{{translation.SideMirror}}</mat-checkbox>
      <mat-checkbox color="primary" name="carSidebar" [(ngModel)]="damageReport.CarSidebar">{{translation.CarSidebar}}</mat-checkbox>
      <mat-checkbox color="primary" name="headlights" [(ngModel)]="damageReport.Headlights">{{translation.Headlights}}</mat-checkbox>
      <mat-checkbox color="primary" name="taillight" [(ngModel)]="damageReport.Taillight">{{translation.Taillight}}</mat-checkbox>
      <mat-checkbox color="primary" name="various" [(ngModel)]="damageReport.Various">{{translation.Various}}</mat-checkbox>
    </div>
  </div>
</div>
<div class="largeBreakLine"></div>
<div class="col-12 unselectable subTitle subhead">Kommentare</div>
<div class="largeBreakLine"></div>
<div class="col-12">
  <div class="comments row">
    <mat-form-field class="col-12 formField">
      <textarea matInput name="comment" placeholder="Interner Kommentar" [(ngModel)]="damageReport.Comment" rows="4"></textarea>
    </mat-form-field>
  </div>
</div>
<div class="col-12">
  <div class="comments row">
    <mat-form-field class="col-12 formField">
      <textarea matInput name="insuranceComment" placeholder="Versicherungskommentar" [(ngModel)]="damageReport.InsuranceComment" rows="4"></textarea>
    </mat-form-field>
  </div>
</div>
<div class="col-12">
  <div id="uploadContent" appDnd class="row dropZone" (fileDropped)="onFileDropped($event)">
    <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowserHandler($event.target.files)">
    <img src="../../../../assets/images/uploadFile.svg" alt="uploadFile">
    <h3>{{translation.DragAndDropFileHere}}</h3>
    <h3>{{translation.Or}}</h3>
    <label id="fileDropButton" class="mat-button" for="fileDropRef">{{translation.BrowseForFile}}</label>
  </div>
</div>
<div class="col-12">
  <div class="files-list">
    <div class="single-file" *ngFor="let file of damageReport.DamageReportDocuments; let i = index" (dblclick)="documentDoubleClick(file)">
      <img *ngIf="!file.FileName.endsWith('.png') && !file.FileName.endsWith('.jpg') && !file.FileName.endsWith('.jpeg')" src="../../../../assets/images/file.svg" width="90px" alt="file">
      <img *ngIf="file.FileName.endsWith('.png') || file.FileName.endsWith('.jpg') || file.FileName.endsWith('.jpeg')" src="data:image/jpeg;base64,{{file.Base64String}}" width="90px" height="90px" alt="file">
      <div class="info">
        <h4 class="name">{{file.FileName}}</h4>
        <div>
          <h4 *ngIf="!file.FileName.startsWith('Schadensdokument_')" class="comment">{{translation.DamageType}}: {{file.DamageType1}} - {{file.DamageType2}}</h4>
          <h4 *ngIf="file.DamageComment != '' && !file.FileName.startsWith('Schadensdokument_')" class="comment">{{translation.Comment}}: {{file.DamageComment}}</h4>
          <p class="size">{{formatBytes(file?.Size)}}</p>
          <app-progress [progress]="file?.Progress"></app-progress>
        </div>
      </div>
      <img src="../../../../assets/images/deleteFile.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i)">
    </div>
  </div>
</div>
<div class="col-12">
  <div id="buttonContent" class="row justify-content-end">
    <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2 col-xl-2">
      <button *ngIf="damageReport.DocNum !== null && damageReport.DocNum !== 0" type="button" class="whiteText" mat-button (click)="delete()">Löschen</button>
    </div>
    <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2 col-xl-2">
      <button type="button" class="whiteText" mat-button (click)="load()">Zurücksetzen</button>
    </div>
    <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2 col-xl-2">
      <button type="button" class="whiteText" mat-button (click)="save()">Speichern</button>
    </div>
  </div>
</div>
</form>
</div>
<app-footer></app-footer>
